// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3WYN_","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2C8Z4","obliqueLine":"membershipbadge_obliqueLine__Nedat"};